// pages/FormViewerPage/services/formViewerService/assignCs.ts — CS assignment logic
import { supabase } from '../../../../supabase/client';
import type { Form } from '../../../../types';

function pickWeightedRandom(agents: { csAgentId: string; percentage?: number }[]): string | undefined {
    const totalPct = agents.reduce((s, a) => s + (a.percentage || 0), 0);
    if (totalPct === 0) {
        const idx = Math.floor(Math.random() * agents.length);
        return agents[idx]?.csAgentId;
    }
    let r = Math.random() * totalPct;
    for (const agent of agents) {
        r -= (agent.percentage || 0);
        if (r <= 0) return agent.csAgentId;
    }
    return agents[agents.length - 1]?.csAgentId;
}

export async function assignCs(form: Form | null): Promise<string | undefined> {
    const csAssgn = form?.thankYouPage?.csAssignment;
    if (!csAssgn) return undefined;
    try {
        if (csAssgn.mode === 'single' && csAssgn.singleAgentId) {
            return csAssgn.singleAgentId;
        }
        if (csAssgn.mode === 'round_robin') {
            const agents = csAssgn.roundRobinAgents;
            if (!agents || agents.length === 0) return undefined;
            const { data: activeCsAgents } = await supabase.rpc('get_active_cs_agents_with_limit', { p_brand_id: form?.brandId || null });
            if (!Array.isArray(activeCsAgents) || activeCsAgents.length === 0) return undefined;
            const eligibleAgents = activeCsAgents.filter((a: any) => a.limit === null || (a.limit > 0 && a.order_count < a.limit));
            const pool = eligibleAgents.length > 0 ? eligibleAgents : activeCsAgents;
            const configuredIds = new Set(agents.map((a: any) => a.csAgentId));
            const matched = pool.filter((a: any) => configuredIds.has(a.assigned_cs_id || a.csAgentId));
            const finalPool = matched.length > 0 ? matched : pool;
            if (finalPool.length === 0) return undefined;
            const pctMap = new Map<string, number>();
            agents.forEach((a: any) => pctMap.set(a.csAgentId, a.percentage));
            const weighted = finalPool.map((a: any) => ({
                csAgentId: a.assigned_cs_id || a.csAgentId,
                percentage: pctMap.get(a.assigned_cs_id || a.csAgentId) || 0,
            }));
            return pickWeightedRandom(weighted);
        }
        return undefined;
    } catch { return undefined; }
}
